import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Pricing from "../pages/pricing/page";
import MSOPricing from "../pages/mso-pricing/page";
import WhyMSO from "../pages/infographic/page";
import Services from "../pages/services/page";
import Partnership from "../pages/partnership/page";
import Audit from "../pages/audit/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/mso-pricing",
    element: <MSOPricing />,
  },
  {
    path: "/partnership",
    element: <Partnership />,
  },
  {
    path: "/why-mso",
    element: <WhyMSO />,
  },
  {
    path: "/audit",
    element: <Audit />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
